import type { AtlasActionState } from '../models/AtlasAccessSummary';

export interface AtlasActionPresentation {
  readonly enabled: boolean;
  readonly message: string | null;
  readonly cta: 'upgrade' | 'request_access' | 'retry' | null;
  readonly showRetry: boolean;
}

export function mapAtlasActionState(state: AtlasActionState): AtlasActionPresentation {
  if (state.state === 'enabled') {
    return { enabled: true, message: null, cta: null, showRetry: false };
  }
  if (state.state === 'unavailable') {
    return {
      enabled: false,
      message: 'Access could not be verified. Retry in a moment.',
      cta: 'retry',
      showRetry: true,
    };
  }
  if (state.state === 'unsupported') {
    return {
      enabled: false,
      message: 'This action is not available for the current chart or selection.',
      cta: null,
      showRetry: false,
    };
  }
  if (state.state === 'pending') {
    return {
      enabled: false,
      message: state.reason === 'approval'
        ? 'This change is awaiting approval.'
        : 'The organization changed. Review and rebase this plan.',
      cta: null,
      showRetry: false,
    };
  }
  if (state.reason === 'plan') {
    return {
      enabled: false,
      message: 'Atlas Advanced is required for this action.',
      cta: 'upgrade',
      showRetry: false,
    };
  }
  return {
    enabled: false,
    message: state.reason === 'role'
      ? 'You need edit access for this action.'
      : 'Your Atlas data access does not include this selection.',
    cta: 'request_access',
    showRetry: false,
  };
}
